<div class="icon-bar">
    <div
      class="icon-bar-img"
      id="uploadFileS"
      value="Browse"
      onclick="document.getElementById('upload').click();"
    >
      <app-icons-free-tools [name]="'pcIcon'" class="h-w"/>
      <input
        id="upload"
        data-name="upload-element"
        #fileInput
        accept=".txt,.doc,.docx,.pdf,.odt,.rtf,.tex"
        type="file"
        (change)="uploadFileSaveRedirect($event)"
      />
    </div>
    <div class="icon-bar-img" (click)="openDropboxChooser()">
      <app-icons-free-tools [name]="'dropboxIcon'"  class="h-w"/>
    </div>
    <div class="icon-bar-img" (click)="gDriveUpload()">
      <app-icons-free-tools [name]="'googleIcon'"  class="h-w"/>
    </div>
  </div>
